var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolutionIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Item Icon",
    clipPath: "url(#clip0_4449_195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.200082 4.43313C0.414097 2.42496 2.01136 1.00019 3.81939 1.00019L12.1754 1C13.9713 1 15.5641 2.40651 15.7881 4.40158C16.0714 6.93032 16.0707 9.03757 15.7854 11.5911C15.562 13.5884 13.9687 15 12.17 15H3.82277C2.01337 15 0.415414 13.5724 0.201416 11.5628C-0.0665827 9.04 -0.0672483 6.94656 0.200082 4.43313ZM3.81939 2.16684C2.53342 2.16684 1.44275 3.15849 1.26743 4.50014H14.7241C14.552 3.15776 13.4614 2.16684 12.1754 2.16684H3.81939ZM1.26143 11.4286C1.04276 9.37095 1.00809 7.62247 1.15876 5.66679H14.8379C14.9953 7.62303 14.9579 9.3773 14.7266 11.4496C14.5733 12.8184 13.4714 13.8333 12.17 13.8333H3.82278C2.51408 13.8333 1.40742 12.8067 1.26143 11.4286ZM5.0668 11.7918C5.36147 11.7918 5.60013 11.5308 5.60013 11.2085C5.60013 10.8862 5.36147 10.6251 5.0668 10.6251H2.93348C2.63881 10.6251 2.40015 10.8862 2.40015 11.2085C2.40015 11.5308 2.63881 11.7918 2.93348 11.7918H5.0668Z",
    fill: "#767A7F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4449_195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionIcon6);
export default __webpack_public_path__ + "static/media/solution_icon_6.69f570c02e1d067475406992612f1d27.svg";
export { ForwardRef as ReactComponent };